import { AbstractControl, FormControl } from '@angular/forms';

export const maskAddress = (control: FormControl | AbstractControl) =>
	setTimeout(() => {
		control.setValue(control.value.replace(/\b\w/g, (c) => c.toUpperCase()));
	}, 0);
